import React, { Fragment, useContext, useState } from 'react'
import * as S from './styles'
import moment from 'moment-timezone'
import { getAnesthetistType } from '../functions'
import {
  EquipamentsModel,
  // SurgicalScheduleModel,
  AppointmentModel
} from 'domain/entities/surgical-schedule-model'

import {
  SurgicalScheduleModelContext,
  SurgicalSchedulingContext
} from '../context'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'
import TextAreaNew from 'presentation/shared/components/TextAreaNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useStores } from 'presentation/hooks/use-stores'
import { useServices } from 'presentation/hooks/use-services'
import { toast } from 'react-toastify'
import LoadingModal from 'presentation/shared/components/LoadingModal'
import { Procedure } from 'presentation/doctor/pages/Patient'
import DividerNew from 'presentation/shared/components/DividerNew'
import Modal from 'presentation/shared/components/Modal'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close.svg'
import { ReactComponent as PeopleCalendarImage } from 'presentation/assets/scheduling-sector/people-calendar.svg'
import { ReactComponent as EquipmentImage } from 'presentation/assets/scheduling-sector/equipment.svg'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { ReactComponent as TriangleAlertIcon } from 'presentation/assets/icons/alert-triangle-filled.svg'

// type SurgeryDetailsInfoType = {
//   surgicalSchedule: SurgicalScheduleModel
// }

// export const SurgeryDetailsInfo = ({
//   surgicalSchedule
// }: SurgeryDetailsInfoType) => {
//   const filteredMainProcedure =
//     surgicalSchedule?.surgical_order?.procedures.filter(
//       (procedure: Procedure) => {
//         return procedure.isMain === true
//       }
//     )

//   const mainProcedure = () => {
//     if (filteredMainProcedure?.length > 0) {
//       return filteredMainProcedure[0]?.description
//     } else {
//       return ''
//     }
//   }

//   return (
//     <>
//       <S.ScrollContainer>
//         {surgicalSchedule.status === 'analyze-canceled' && (
//           <S.CancelledContainer>
//             <S.CancelledTitle>Motivo do cancelamento:</S.CancelledTitle>

//             <S.CancelledText>
//               {surgicalSchedule.reason_to_cancel_solicitation}
//             </S.CancelledText>

//             <S.CancelledText>
//               Cancelado por {surgicalSchedule.cancel_solicitation_by_name} {''}
//               em{' '}
//               {moment(surgicalSchedule.cancel_solicitation_date).format(
//                 'DD/MM/YYYY [às] HH:mm[h]'
//               )}
//             </S.CancelledText>
//           </S.CancelledContainer>
//         )}
//         <S.FlexContainer>
//           <S.ContainerInfo>
//             {surgicalSchedule.status === 'scheduled' && (
//               <>
//                 <strong>Agendamento:</strong>
//                 {surgicalSchedule?.anesthetist?.type && (
//                   <p>
//                     {getAnesthetistType(surgicalSchedule?.anesthetist)?.title}
//                     &nbsp;
//                     <span>
//                       {getAnesthetistType(surgicalSchedule?.anesthetist)?.data}{' '}
//                     </span>
//                   </p>
//                 )}
//                 <p>
//                   Sala: &nbsp;
//                   <span>
//                     {surgicalSchedule?.surgical_order?.surgery_center_name}-
//                     {
//                       surgicalSchedule.appointments?.filter(
//                         (appointment: AppointmentModel) => {
//                           return appointment.status === 'scheduled'
//                         }
//                       )[0]?.room_id
//                     }
//                     {/* {surgicalSchedule?.surgical_order?.room_id} */}
//                   </span>
//                 </p>
//                 <p>
//                   Duração: &nbsp;
//                   <span>
//                     {
//                       surgicalSchedule.appointments?.filter(
//                         (appointment: AppointmentModel) => {
//                           return appointment.status === 'scheduled'
//                         }
//                       )[0]?.time
//                     }
//                   </span>
//                 </p>
//                 <p>
//                   Data e Horário da Cirurgia: &nbsp;
//                   <span>
//                     {moment(surgicalSchedule?.surgery_day)
//                       // .subtract(3, 'hours')
//                       .format('DD/MM/YYYY HH:mm')}
//                   </span>
//                 </p>
//               </>
//             )}
//           </S.ContainerInfo>

//           {surgicalSchedule.status === 'scheduled' && surgicalSchedule.id && (
//             <S.Separator />
//           )}

//           {surgicalSchedule.id && (
//             <S.ContainerInfo>
//               <strong>Solicitação:</strong>
//               {surgicalSchedule?.anesthetist?.type && (
//                 <p>
//                   {getAnesthetistType(surgicalSchedule?.anesthetist)?.title}
//                   &nbsp;
//                   <span>
//                     {getAnesthetistType(surgicalSchedule?.anesthetist)?.data}{' '}
//                   </span>
//                 </p>
//               )}
//               <p>
//                 Sala: &nbsp;
//                 <span>
//                   {surgicalSchedule?.surgical_order?.surgery_center_name}-
//                   {
//                     surgicalSchedule.appointments?.filter(
//                       (appointment: AppointmentModel) => {
//                         return appointment.status === 'pre-scheduling'
//                       }
//                     )[0]?.room_id
//                   }
//                 </span>
//               </p>
//               <p>
//                 Duração: &nbsp;
//                 <span>
//                   {
//                     surgicalSchedule.appointments?.filter(
//                       (appointment: AppointmentModel) => {
//                         return appointment.status === 'pre-scheduling'
//                       }
//                     )[0]?.time
//                   }
//                 </span>
//               </p>

//               <p>Data e Horário da Cirurgia: &nbsp;</p>
//               {surgicalSchedule?.appointments
//                 ?.filter((appointment: AppointmentModel) => {
//                   return appointment.status === 'pre-scheduling'
//                 })
//                 ?.map((appointment: AppointmentModel, index: number) => {
//                   return (
//                     <Fragment key={index}>
//                       <p>
//                         <span>
//                           Opção {index + 1} -{' '}
//                           {moment
//                             .utc(appointment?.start_date)
//                             .format('DD/MM/YYYY HH:mm')}
//                           {appointment?.is_preferential && ' (preferencial)'}
//                         </span>
//                       </p>
//                     </Fragment>
//                   )
//                 })}

//               {surgicalSchedule.status === 'requested' && (
//                 <p>
//                   <span>
//                     {' '}
//                     <strong className="orange">Atenção:</strong> Esta cirurgia
//                     ainda não foi agendada, apenas solicitada.
//                   </span>
//                 </p>
//               )}
//             </S.ContainerInfo>
//           )}
//         </S.FlexContainer>

//         <S.ContainerInfo>
//           {!!surgicalSchedule?.reason_to_scheduling_is_another_date && (
//             <>
//               <p className="black"> Motivo de escolher outra data/horário:</p>
//               <span>
//                 {surgicalSchedule?.reason_to_scheduling_is_another_date}
//               </span>
//             </>
//           )}

//           {!!surgicalSchedule?.observation_to_scheduling_is_another_date && (
//             <>
//               <p className="black"> Observações:</p>
//               <span>
//                 {surgicalSchedule?.observation_to_scheduling_is_another_date}
//               </span>
//             </>
//           )}
//         </S.ContainerInfo>

//         <DividerNew />

//         <S.ContainerInfo>
//           <strong>Dados do paciente:</strong>
//           <h1 className="schedule-name">{surgicalSchedule?.patient?.name}</h1>
//           <p className="schedule-info">
//             Data de Nascimento: &nbsp;
//             <span>
//               {moment
//                 .utc(surgicalSchedule?.patient?.birthday)
//                 .format('DD/MM/YYYY')}
//             </span>
//           </p>
//           <p className="schedule-info">
//             Convênio:&nbsp;
//             <span>
//               {surgicalSchedule?.surgical_order?.health_insurance.name}
//             </span>
//           </p>
//         </S.ContainerInfo>

//         <DividerNew />

//         <S.FlexContainer style={{ justifyContent: 'space-between' }}>
//           <S.ContainerInfo style={{ maxWidth: '400px' }}>
//             <strong>Informações da cirurgia:</strong>

//             <h1 className="schedule-name">{mainProcedure()}</h1>

//             <p>
//               Aviso cirúrgico: &nbsp;
//               <span>{surgicalSchedule?.surgical_order?.id}</span>
//             </p>

//             <p>
//               Especialidade: &nbsp;
//               <span>{surgicalSchedule?.doctor?.specialty}</span>
//             </p>

//             <p>
//               Cirurgião(ã) responsável: &nbsp;
//               <span>{surgicalSchedule?.doctor?.name}</span>
//             </p>

//             <p>
//               Precisa de banco de Sangue?: &nbsp;
//               <span>
//                 {surgicalSchedule?.surgical_order?.blood_reserve
//                   ? 'Sim'
//                   : 'Não'}
//               </span>
//             </p>

//             <p>
//               Precisa de CTI? &nbsp;
//               <span>
//                 {surgicalSchedule?.surgical_order?.cti ? 'Sim' : 'Não'}
//               </span>
//             </p>

//             <p>
//               Congelação: &nbsp;
//               <span>
//                 {surgicalSchedule?.surgical_order?.freezing ? 'Sim' : 'Não'}
//               </span>
//             </p>

//             <p>
//               Técnica: &nbsp;
//               <span>{surgicalSchedule?.surgical_order?.tecnic}</span>
//             </p>

//             <p>
//               Observações gerais: &nbsp;
//               <span>{surgicalSchedule?.general_observation}</span>
//             </p>
//           </S.ContainerInfo>

//           <S.Separator />

//           <S.ContainerInfo style={{ width: '400px' }}>
//             <p>
//               Precisa incluir equipamentos? &nbsp;
//               <span>
//                 {surgicalSchedule?.equipaments?.length ? 'Sim' : 'Não'}
//               </span>
//             </p>

//             {surgicalSchedule?.equipaments?.length > 0 ? (
//               <S.Table>
//                 <thead>
//                   <tr>
//                     <th>Código</th>
//                     <th>Equipamento</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {surgicalSchedule?.equipaments.map(
//                     (equipment: EquipamentsModel) => {
//                       return (
//                         <tr key={equipment.code}>
//                           <td>{equipment.code || 'Sem código'}</td>
//                           <td className="description">{equipment?.name}</td>
//                         </tr>
//                       )
//                     }
//                   )}
//                 </tbody>
//               </S.Table>
//             ) : (
//               <S.SoftText>Nenhum equipamento foi adicionado</S.SoftText>
//             )}
//           </S.ContainerInfo>
//         </S.FlexContainer>
//       </S.ScrollContainer>
//     </>
//   )
// }

export const FinishScheduleModal = ({
  setShowModalEvent,
  setUnavailableEquipments,
  setShowUnavailableEquipmentModal,
  setShowFinishModal,
  setShowDivergencyModal
}: any) => {
  const { state, dispatch } = useContext<any>(
    SurgicalSchedulingContext
  ) as SurgicalScheduleModelContext

  const [isLoading, setIsLoading] = useState(false)
  const [unavailableType, setUnavailableType] = useState('')
  const [showUnavailableModal, setShowUnavailableModal] = useState(false)

  const stores = useStores()
  const currentUser = stores.currentAccount
  const surgicalScheduleService = useServices().surgicalSchedule

  const filteredMainProcedure = state.surgical_order?.procedures.filter(
    (procedure: Procedure) => {
      return procedure.isMain === true
    }
  )

  const mainProcedure = filteredMainProcedure[0].description || ''

  async function finishSchedule() {
    const dateWithHourStart = state.selectedDate + ' ' + state.selectedHourStart
    const dateWithHourEnd = state.selectedDate + ' ' + state.selectedHourEnd

    try {
      setIsLoading(true)
      await surgicalScheduleService.finishSurgicalSchedule({
        scheduling_id: state.id,
        start_date: moment.utc(dateWithHourStart).toISOString(),
        end_date: moment.utc(dateWithHourEnd).toISOString(),
        room_id: state.selectedRoomId,
        surgical_center_id: state.surgical_order.room_id,
        surgery_date: state.selectedDate,
        observation_to_scheduling_is_another_date:
          state.observation_to_scheduling_is_another_date,
        reason_to_scheduling_is_another_date:
          state.reason_to_scheduling_is_another_date,
        scheduled_by_name: currentUser.getCurrentAccount().user.name,
        scheduled_by_id: currentUser.getCurrentAccount().user.user_id,
        equipments: state.equipaments.length > 0 ? state.equipaments : []
      })

      dispatch({
        type: 'FINISH_SCHEDULE_SUCCESS',
        payload: !state.toggleRefreshCalendar
      })

      setShowModalEvent(false)
      toast.success('Agendamento realizado com sucesso.')
    } catch (error: any) {
      const errorCode = error?.message

      if (errorCode === 'TIME_UNAVAILABLE') {
        setShowUnavailableModal(true)
        setUnavailableType('TIME_UNAVAILABLE')
        return
      }

      if (errorCode === 'EQUIPMENT_UNAVAILABLE') {
        setShowUnavailableModal(true)
        setUnavailableType('EQUIPMENT_UNAVAILABLE')
        return
      }

      if (error?.message) {
        try {
          const unavailableEquipments = JSON.parse(error.message)

          if (
            Array.isArray(unavailableEquipments) &&
            unavailableEquipments.length > 0
          ) {
            setShowDivergencyModal(false)
            setShowFinishModal(false)
            setUnavailableEquipments(unavailableEquipments)
            setShowUnavailableEquipmentModal(true)
            return
          }
        } catch (e) {
          console.warn(error.message)
        }
      }
      toast.error('Falha ao finalizar agendamento')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <S.ScrollContainer>
        <S.FlexContainer>
          <S.ContainerInfo>
            <>
              <strong>Agendamento:</strong>
              {state?.anesthetist?.type && (
                <p>
                  {getAnesthetistType(state?.anesthetist)?.title}&nbsp;
                  <span>{getAnesthetistType(state?.anesthetist)?.data} </span>
                </p>
              )}
              <p>
                Sala: &nbsp;
                <span>
                  {state?.surgical_order?.surgery_center_name}-
                  {state.selectedRoomId}
                </span>
              </p>
              <p>
                Duração: &nbsp;
                <span>
                  {state.appointments?.filter(
                    (appointment: AppointmentModel) => {
                      return appointment.status === 'scheduled'
                    }
                  )[0]?.time || state.time.requested_time}
                </span>
              </p>
              <p>
                Data e Horário da Cirurgia: &nbsp;
                <span>
                  {moment(state?.selectedDate).format('DD/MM/YYYY') +
                    ' ' +
                    state.selectedHourStart}
                </span>
              </p>
            </>
          </S.ContainerInfo>

          <S.Separator />

          {state.id && (
            <S.ContainerInfo>
              <strong>Solicitação:</strong>
              {state?.anesthetist?.type && (
                <p>
                  {getAnesthetistType(state?.anesthetist)?.title}&nbsp;
                  <span>{getAnesthetistType(state?.anesthetist)?.data} </span>
                </p>
              )}
              <p>
                Solicitante: &nbsp;
                <span>{state?.requested_by_name}</span>
              </p>
              <p>
                Sala: &nbsp;
                <span>
                  {state?.surgical_order?.surgery_center_name}-
                  {
                    state.appointments?.filter(
                      (appointment: AppointmentModel) => {
                        return appointment.status === 'pre-scheduling'
                      }
                    )[0]?.room_id
                  }
                  {/* {state?.surgical_order?.room_id} */}
                </span>
              </p>
              <p>
                Duração: &nbsp;
                <span>
                  {
                    state.appointments?.filter(
                      (appointment: AppointmentModel) => {
                        return appointment.status === 'pre-scheduling'
                      }
                    )[0]?.time
                  }
                </span>
              </p>

              <p>Data e Horário da Cirurgia: &nbsp;</p>
              {state?.appointments
                .filter((appointment: AppointmentModel) => {
                  return appointment.status === 'pre-scheduling'
                })
                ?.map((appointment: AppointmentModel, index: number) => {
                  return (
                    <Fragment key={index}>
                      <p>
                        <span>
                          Opção {index + 1} -{' '}
                          {moment
                            .utc(appointment?.start_date)
                            .format('DD/MM/YYYY HH:mm')}
                          {appointment?.is_preferential && ' (preferencial)'}
                        </span>
                      </p>
                    </Fragment>
                  )
                })}

              {state.status === 'requested' && (
                <p>
                  <span>
                    {' '}
                    <strong className="orange">Atenção:</strong> Esta cirurgia
                    ainda não foi agendada, apenas solicitada.
                  </span>
                </p>
              )}
            </S.ContainerInfo>
          )}
        </S.FlexContainer>

        <S.ContainerInfo>
          {!!state.reason_to_scheduling_is_another_date && (
            <>
              <p className="black"> Motivo de escolher outra data/horário:</p>
              <span>{state.reason_to_scheduling_is_another_date}</span>
            </>
          )}

          {!!state.observation_to_scheduling_is_another_date && (
            <>
              <p className="black"> Observações:</p>
              <span>{state.observation_to_scheduling_is_another_date}</span>
            </>
          )}
        </S.ContainerInfo>

        <DividerNew />

        <S.ContainerInfo>
          <strong>Dados do paciente:</strong>
          <h1 className="schedule-name">{state?.patient?.name}</h1>
          <p className="schedule-info">
            Data de Nascimento: &nbsp;
            <span>
              {moment.utc(state?.patient?.birthday).format('DD/MM/YYYY')}
            </span>
          </p>
          <p className="schedule-info">
            Convênio:&nbsp;
            <span>{state?.surgical_order?.health_insurance.name}</span>
          </p>
        </S.ContainerInfo>

        <DividerNew />

        <S.FlexContainer style={{ justifyContent: 'space-between' }}>
          <S.ContainerInfo style={{ maxWidth: '400px' }}>
            <strong>Informações da cirurgia:</strong>
            <h1 className="schedule-name">{mainProcedure}</h1>

            <p>
              Aviso cirúrgico: &nbsp;
              <span>{state?.surgical_order?.id}</span>
            </p>

            <p>
              Especialidade: &nbsp;
              <span>{state?.doctor?.specialty}</span>
            </p>

            <p>
              Cirurgião(ã) responsável: &nbsp;
              <span>{state?.doctor?.name}</span>
            </p>

            <p>
              Precisa de banco de Sangue?: &nbsp;
              <span>
                {state?.surgical_order?.blood_reserve ? 'Sim' : 'Não'}
              </span>
            </p>

            <p>
              Precisa de CTI? &nbsp;
              <span>{state?.surgical_order?.cti ? 'Sim' : 'Não'}</span>
            </p>

            <p>
              Congelação: &nbsp;
              <span>{state?.surgical_order?.freezing ? 'Sim' : 'Não'}</span>
            </p>

            <p>
              Técnica: &nbsp;
              <span>{state?.surgical_order?.tecnic}</span>
            </p>

            <p>
              Observações gerais: &nbsp;
              <span>{state?.general_observation}</span>
            </p>
          </S.ContainerInfo>

          <S.Separator />

          <S.ContainerInfo style={{ width: '400px' }}>
            <p>
              Precisa incluir equipamentos? &nbsp;
              <span>{state?.equipaments?.length ? 'Sim' : 'Não'}</span>
            </p>

            {state?.equipaments?.length > 0 ? (
              <S.Table width={'393px'}>
                <tr>
                  <th>Código</th>
                  <th>Equipamento</th>
                </tr>
                {state?.equipaments.map((equipment: EquipamentsModel) => {
                  return (
                    <tr key={equipment.code}>
                      <td>{equipment.code || 'Sem código'}</td>
                      <td className="description">{equipment?.name}</td>
                    </tr>
                  )
                })}
              </S.Table>
            ) : (
              <S.SoftText>Nenhum equipamento foi adicionado</S.SoftText>
            )}
          </S.ContainerInfo>
        </S.FlexContainer>

        <DividerNew />
        <S.ButtonPanel style={{ width: '50%', marginLeft: 'auto' }}>
          <ButtonNew variant="text" onClick={() => setShowModalEvent(false)}>
            Cancelar
          </ButtonNew>
          <ButtonNew onClick={finishSchedule}>Agendar</ButtonNew>
        </S.ButtonPanel>
        <LoadingModal show={isLoading} />
      </S.ScrollContainer>
      <UnavailableModal
        setShowUnavailableModal={setShowUnavailableModal}
        showUnavailableModal={showUnavailableModal}
        unavailableType={unavailableType}
        setShowModalEvent={setShowModalEvent}
      />
    </>
  )
}

export const DivergencyModal = ({
  setShowFinishModal,
  setShowDivergencyModal,
  setShowModalEvent
}: any) => {
  const { dispatch, state } = useContext<any>(
    SurgicalSchedulingContext
  ) as SurgicalScheduleModelContext

  const validationSchema = yup.object().shape({
    justificative: yup.string().required(),
    other_reason: yup.string().when('justificative', {
      is: 'Outro',
      then: yup.string().required('Motivo obrigatório')
    }),
    observation: yup.string()
  })

  const formik = useFormik({
    initialValues: {
      justificative: '',
      other_reason: '',
      observation: ''
    },
    validationSchema: validationSchema,
    validateOnMount: true,
    onSubmit: async (values) => {
      const formatedOtherReason = values.other_reason
        ? ': ' + values.other_reason
        : ''

      dispatch({
        type: 'REASON_SCHEDULING_ANOTHER_DATE',
        payload: values.justificative + formatedOtherReason
      })
      dispatch({
        type: 'OBSERVATION_SCHEDULING_ANOTHER_DATE',
        payload: values.observation
      })

      setShowFinishModal(true)
      setShowDivergencyModal(false)
    }
  })

  function closeDivergencyModal() {
    setShowModalEvent(false)
  }

  const optionsJustificative = [
    {
      label: 'Não havia disponibilidade no horário solicitado',
      value: 'Não havia disponibilidade no horário solicitado'
    },
    {
      label: 'Não havia disponibilidade na data solicitada',
      value: 'Não havia disponibilidade na data solicitada'
    },
    {
      label: 'Médico/secretária solicitou outra data por telefone',
      value: 'Médico/secretária solicitou outra data por telefone'
    },
    {
      label: 'Não havia equipamento para aquele horário',
      value: 'Não havia equipamento para aquele horário'
    },
    { label: 'Outro', value: 'Outro' }
  ]

  return (
    <S.WrapperForm onSubmit={formik.handleSubmit}>
      <span className="black">
        Você está escolhendo uma data/horário que não foi solicitada.
      </span>

      <S.FlexContainer style={{ marginTop: '10px' }}>
        <S.ContainerInfo>
          <p>Datas Solicitadas: </p>

          {state?.appointments
            .filter((appointment: AppointmentModel) => {
              return appointment.status === 'pre-scheduling'
            })
            ?.map((appointment: AppointmentModel, index: number) => {
              return (
                <p key={index}>
                  <span>
                    Opção {index + 1} -{' '}
                    {moment
                      .utc(appointment?.start_date)
                      .format('DD/MM/YYYY HH:mm')}
                    {appointment?.is_preferential && ' (preferencial)'}
                  </span>
                </p>
              )
            })}
        </S.ContainerInfo>
        <S.Separator />
        <S.ContainerInfo>
          <p>Data escolhida por você:</p>
          <span>
            {' '}
            {moment(state?.selectedDate).format('DD/MM/YYYY') +
              ' - ' +
              state.selectedHourStart +
              ' às ' +
              state.selectedHourEnd}{' '}
          </span>
          <p>
            Duração:
            <span> {state.time.requested_time}</span>
          </p>
        </S.ContainerInfo>
      </S.FlexContainer>

      <div style={{ display: 'flex', marginTop: '30px' }}>
        <span className="black">Informe o motivo de escolher outra data* </span>
      </div>

      <SelectFieldNew
        required={true}
        name="justificative"
        value={formik.values.justificative}
        items={optionsJustificative}
        onInputChange={formik.handleChange('justificative')}
      />

      {formik.values.justificative === 'Outro' && (
        <>
          <div style={{ display: 'flex', marginTop: '30px' }}>
            <span className="black">Qual o motivo? *</span>
          </div>
          <TextFieldNew
            name="other_reason"
            value={formik.values.other_reason.trimStart()}
            onInputChange={formik.handleChange('other_reason')}
          />
        </>
      )}

      <div style={{ display: 'flex', marginTop: '30px' }}>
        <span className="black">Observações</span>
      </div>
      <TextAreaNew
        name="observation"
        placeholder="Observações"
        rows={4}
        style={{ marginBottom: '10px' }}
        onInputChange={formik.handleChange('observation')} //
        required
      />

      <S.ButtonPanel>
        <ButtonNew variant="text" onClick={closeDivergencyModal}>
          Cancelar
        </ButtonNew>
        <ButtonNew
          disabled={
            !formik.isValid ||
            (formik.values.other_reason.trimStart() === '' &&
              formik.values.justificative === 'Outro')
          }
          type="submit"
        >
          Ok, próximo
        </ButtonNew>
      </S.ButtonPanel>
    </S.WrapperForm>
  )
}

const UnavailableModal = ({
  setShowUnavailableModal,
  showUnavailableModal,
  unavailableType,
  setShowModalEvent
}: any) => {
  function getUnavailableType() {
    if (unavailableType === 'TIME_UNAVAILABLE') {
      return {
        title: 'Horário indisponível',
        description:
          'O horário definido por você não está mais disponível. Selecione um novo horário.',
        image: <PeopleCalendarImage />
      }
    }

    if (unavailableType === 'EQUIPMENT_UNAVAILABLE') {
      return {
        title: 'Equipamento indisponível',
        description:
          'Um ou mais equipamentos  solicitados não está disponível para o horário escolhido. Selecione um novo horário.',
        image: <EquipmentImage />
      }
    } else {
      return {
        title: 'Indisponível',
        description: 'Indisponível'
      }
    }
  }

  function closeModals() {
    setShowModalEvent(false)
    setShowUnavailableModal(false)
  }

  return (
    <Modal
      style={{ display: 'block', width: '650px', padding: 20 }}
      show={showUnavailableModal}
      close={closeModals}
      preventAutomateClose
    >
      <S.ModalInfo>
        <S.HeaderModal>
          <S.Title>{getUnavailableType().title}</S.Title>
          <CloseIcon onClick={closeModals} />
        </S.HeaderModal>
      </S.ModalInfo>
      <DividerNew marginBottom="5px" marginTop="5px" />
      <S.Subtitle>{getUnavailableType().description}</S.Subtitle>
      {getUnavailableType().image}
      <S.ButtonPanel>
        <ButtonNew onClick={closeModals}>Selecionar novo horário</ButtonNew>
      </S.ButtonPanel>
    </Modal>
  )
}

export const UnavailableEquipmentModal = ({
  setShowUnavailableEquipmentModal,
  showUnavailableEquipmentModal,
  setShowModalEvent,
  unavailableEquipments
}: any) => {
  function closeModals() {
    setShowUnavailableEquipmentModal(false)
    setShowModalEvent(false)
  }

  return (
    <Modal
      style={{ display: 'block', width: '700px', padding: 25 }}
      show={showUnavailableEquipmentModal}
      close={closeModals}
      preventAutomateClose
    >
      <S.ModalInfo>
        <S.HeaderModal>
          <S.Title>Equipamento indisponível</S.Title>
          <CloseIcon onClick={closeModals} />
        </S.HeaderModal>
      </S.ModalInfo>
      <DividerNew marginBottom="5px" marginTop="10px" />
      <S.Subtitle>
        Os equipamentos abaixo estão indisponíveis no horário que você
        selecionou:
      </S.Subtitle>

      <S.TableWrapper>
        <EquipmentsTable equipments={unavailableEquipments} width={'670px'} />
      </S.TableWrapper>

      <S.ObservationWrapper>
        <S.TriangleAlertIconWrapper>
          <TriangleAlertIcon />
        </S.TriangleAlertIconWrapper>
        <SupportTextNew
          weight="semiBold"
          size="small"
          style={{ textAlign: 'left' }}
        >
          Consulte outro horário disponível.
        </SupportTextNew>
      </S.ObservationWrapper>
    </Modal>
  )
}

type EquipmentsTableProps = {
  width: string
  equipments: EquipamentsModel[]
}
const EquipmentsTable = ({ width, equipments }: EquipmentsTableProps) => {
  return (
    <>
      {equipments?.length > 0 ? (
        <S.Table width={width}>
          <tr>
            <th>Código</th>
            <th>Equipamento</th>
          </tr>
          {equipments.map((equipment: EquipamentsModel) => {
            return (
              <tr key={equipment.code}>
                <td>{equipment.code || 'Sem código'}</td>
                <td className="description">{equipment?.name}</td>
              </tr>
            )
          })}
        </S.Table>
      ) : (
        <S.SoftText>Nenhum equipamento foi adicionado</S.SoftText>
      )}
    </>
  )
}
